import { render, staticRenderFns } from "./StockBrowserBranchSingle.vue?vue&type=template&id=514f64f6&scoped=true&"
import script from "./StockBrowserBranchSingle.vue?vue&type=script&lang=js&"
export * from "./StockBrowserBranchSingle.vue?vue&type=script&lang=js&"
import style0 from "./StockBrowserBranchSingle.vue?vue&type=style&index=0&id=514f64f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514f64f6",
  null
  
)

export default component.exports